import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

const OPTIONS = [
    { label: 'Fixed Date', value: 1 },
    { label: 'Random Month', value: 2 },
]

export default function SelectMonth({...props}) {

    const myProps = {
        placeholder: '', label: 'Select Date Option',
        firstSelect: true, isClearable: true, options: OPTIONS,
        icon: {icon: 'calendar-day'}, isMulti: true,
        ...props
    }

    return <SelectSeeker {...myProps} />
}